/* eslint-disable import/prefer-default-export */

export function byId(state, action) {
  const { designId, containerId } = action.payload;

  const changedEstimate = state[designId];
  const updatedContainerIds = changedEstimate.containers.filter(givenId => givenId !== containerId);

  const updatedEstimate = Object.assign({}, changedEstimate, { containers: updatedContainerIds });

  const updatedByIds = { [designId]: updatedEstimate };

  return { ...state, ...updatedByIds };
}
